export const languages = [
    { short: "en", full: "English" },
    { short: "ru", full: "русский" },
]

export const uiStrings = {
    'welcome':
    {
        en: "Welcome to our website!",
        ru: "Добро пожаловать на наш сайт!",
    },
    


}